(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pw-header"]) return;
  try {
    
document.addEventListener('keydown', event => {if(event.key==='Escape'){const menu=document.querySelector('.sh-menu[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}}});
document.addEventListener('click',event=>{const link=event.target.closest('.sh-menu nav a');if(link)link.closest('details').open=false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-product"]) return;
  try {
    
document.addEventListener('change',event=>{if(event.target.matches('[data-pw-variant-selector]'))event.target.form.requestSubmit();});
document.addEventListener('click',event=>{const adjust=event.target.closest('[data-sh-quantity]');if(adjust&&!adjust.disabled){const input=adjust.parentElement.querySelector('input');if(adjust.dataset.shQuantity==='up')input.stepUp();else input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));}const zoom=event.target.closest('[data-sh-zoom]');if(zoom){const dialog=document.getElementById(zoom.dataset.shZoom);if(dialog)dialog.showModal();}const close=event.target.closest('[data-sh-close]');if(close)close.closest('dialog').close();if(event.target.matches('dialog.image-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});

  } catch(e) { console.error(e); }
})();
})();
